export default '/build/3fe10d2a.svg'